import { put, takeLatest } from 'redux-saga/effects';
import helpers from 'utils/helpers';
import { unset } from 'lodash';
const { rp } = helpers;

const SET_REDUX_STATE = 'SET_REDUX_STATE';

const CAMPAIGN_ACTIVE_REQUEST = 'CAMPAIGN_ACTIVE_REQUEST';
const CAMPAIGN_ACTIVE_SUCCESS = 'CAMPAIGN_ACTIVE_SUCCESS';
const CAMPAIGN_ACTIVE_FAILURE = 'CAMPAIGN_ACTIVE_FAILURE';

const GET_AVAILABLE_CAMPAIGNS_REQUEST = 'GET_AVAILABLE_CAMPAIGNS_REQUEST';
const GET_AVAILABLE_CAMPAIGNS_SUCCESS = 'GET_AVAILABLE_CAMPAIGNS_SUCCESS';
const GET_AVAILABLE_CAMPAIGNS_FAILURE = 'GET_AVAILABLE_CAMPAIGNS_FAILURE';

const OFFER_GIFT_REQUEST = 'OFFER_GIFT_REQUEST';
const OFFER_GIFT_SUCCESS = 'OFFER_GIFT_SUCCESS';
const OFFER_GIFT_FAILURE = 'OFFER_GIFT_FAILURE';

const GET_USERINFO_REQUEST = 'GET_USERINFO_REQUEST ';
const GET_USERINFO_SUCCESS = 'GET_USERINFO_SUCCESS';
const GET_USERINFO_FAILURE = 'GET_USERINFO_FAILURE';

export const campaignActiveRequest = params => ({
  type: CAMPAIGN_ACTIVE_REQUEST,
  ...params
});

export const getAvailableCampaignsRequest = params => ({
  type: GET_AVAILABLE_CAMPAIGNS_REQUEST,
  ...params
});

export const offerGiftRequest = params => ({
  type: OFFER_GIFT_REQUEST,
  ...params
});

export const getCampaignUserInfoRequest = params => ({
  type: GET_USERINFO_REQUEST,
  ...params
});

function* campaignActive(action) {
  let { campaignSlug } = action;

  var options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/campaign/${campaignSlug}/active`,
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      localStorage.setItem('campaign', campaignSlug);
      yield put({
        type: CAMPAIGN_ACTIVE_SUCCESS,
        campaignData: data.data
      });
    } else {
      yield put({ type: CAMPAIGN_ACTIVE_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: CAMPAIGN_ACTIVE_FAILURE });
  }
}

function* getAvailableCampaigns(action) {
  let { orderRef } = action;

  var options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/campaign/${orderRef}/available-campaigns`,
    body: {},
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: GET_AVAILABLE_CAMPAIGNS_SUCCESS,
        campaignData: data.data.resources
      });
    } else {
      yield put({ type: GET_AVAILABLE_CAMPAIGNS_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_AVAILABLE_CAMPAIGNS_FAILURE });
  }
}

function* offerGift(action) {
  let { campaignSlug, orderRef, memberRef, lastName, firstName } = action;

  var options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/campaign/${campaignSlug}/offer-gift/${orderRef}`,
    body: { memberRef, lastName, firstName },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      localStorage.removeItem('campaign');
      yield put({
        type: OFFER_GIFT_SUCCESS,
        memberRef: data.data.memberRef
      });
    } else {
      yield put({ type: OFFER_GIFT_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: OFFER_GIFT_FAILURE });
  }
}

function* getCampaignUserInfo(action) {
  let { orderRef } = action;
  var options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/campaign/${orderRef}/userInfo`,
    body: {},
    json: true
  };
  try {
    const data = yield rp(options);
    if (data.success) {
      yield put({
        type: GET_USERINFO_SUCCESS,
        campaignUserExist: !!data.data.name,
        campaignName: data.data.name || '',
        memberRef: data.data.memberRef || '',
        firstName: data.data.firstName || '',
        lastName: data.data.lastName || ''
      });
    } else {
      yield put({
        type: GET_USERINFO_FAILURE
      });
    }
  } catch (e) {
    console.error(e);
    yield put({
      type: GET_USERINFO_FAILURE
    });
  }
}

function* saga() {
  yield takeLatest(CAMPAIGN_ACTIVE_REQUEST, campaignActive);
  yield takeLatest(GET_AVAILABLE_CAMPAIGNS_REQUEST, getAvailableCampaigns);
  yield takeLatest(OFFER_GIFT_REQUEST, offerGift);
  yield takeLatest(GET_USERINFO_REQUEST, getCampaignUserInfo);
}

const reducer = (state = {}, action) => {
  const { props } = action;
  switch (action.type) {
    case SET_REDUX_STATE:
      return {
        ...state,
        ...props.campaigns
      };
    case CAMPAIGN_ACTIVE_REQUEST:
      return {
        ...state
      };
    case CAMPAIGN_ACTIVE_SUCCESS:
      return {
        ...state,
        campaignData: action.campaignData
      };
    case CAMPAIGN_ACTIVE_FAILURE:
      return {
        ...state
      };
    case GET_AVAILABLE_CAMPAIGNS_REQUEST: {
      const newState = { ...state };
      unset(newState, 'offerGiftSuccess');
      return newState;
    }
    case GET_AVAILABLE_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        availableCampaigns: action.campaignData
      };
    case GET_AVAILABLE_CAMPAIGNS_FAILURE:
      return {
        ...state
      };
    case OFFER_GIFT_REQUEST:
      return {
        ...state
      };
    case OFFER_GIFT_SUCCESS:
      return {
        ...state,
        offerGiftSuccess: true,
        memberRef: action.memberRef
      };
    case OFFER_GIFT_FAILURE:
      return {
        ...state
      };
    case GET_USERINFO_REQUEST:
      return {
        ...state
      };
    case GET_USERINFO_SUCCESS:
      return {
        ...state,
        campaignUserExist: action.campaignUserExist,
        campaignName: action.campaignName,
        memberRef: action.memberRef,
        firstName: action.firstName,
        lastName: action.lastName
      };
    case GET_USERINFO_FAILURE:
      return {
        ...state,
        campaignUserExist: false
      };
    default:
      return state;
  }
};

export default {
  saga,
  reducer
};
